/* Iter122dv · Pagina Impostazioni deprecata: unificata dentro "Impostazioni & Account" (/pannello).
   Backward compat: ridirige alla nuova pagina con il tab "Profilo Studio" pre-selezionato. */
import { Navigate } from "react-router-dom";

export default function Impostazioni() {
  return <Navigate to="/pannello?tab=profilo-studio" replace />;
}
